import { useEffect } from "react";
import { Track } from "livekit-client";

export function useMediaShortcuts({
  room,
  toggleMic,
  toggleCamera,
  notify,
}: {
  room: any;
  toggleMic: (enabled: boolean) => void;
  toggleCamera: (enabled: boolean) => void;
  notify: (msg: string) => void;
}) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const isCtrl = e.ctrlKey || e.metaKey;
      const micTrack = room.localParticipant.getTrack(Track.Source.Microphone);
      const camTrack = room.localParticipant.getTrack(Track.Source.Camera);

      if (isCtrl && e.key.toLowerCase() === "m") {
        e.preventDefault();
        const micEnabled = !!micTrack?.track;
        toggleMic(!micEnabled);
        notify(`Microphone ${micEnabled ? "muted" : "unmuted"}`);
      }

      if (isCtrl && e.key.toLowerCase() === "o") {
        e.preventDefault();
        const camEnabled = !!camTrack?.track;
        toggleCamera(!camEnabled);
        notify(`Camera ${camEnabled ? "turned off" : "turned on"}`);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [room, toggleMic, toggleCamera, notify]);
}